import MuiTabs from "@mui/material/Tabs";

export default function Tabs(props) {
  return <MuiTabs {...props} />;
}
